<ng-template #htmlTooltip>
  @if(errorsList().length > 0) {
    @for (error of errorsList(); track $index) {
      <div>
        <span class="error">X</span>&nbsp;
        <span>{{ error }}</span>
      </div>
    }
  }
</ng-template>

<div class="operations-start-date-status" role="status" [disableTooltip]="errorsList().length === 0" [ngbTooltip]="htmlTooltip" tooltipClass="operationsTooltip" [class.success]="status() === 'success'" [class.warning]="status() === 'warning'" [class.error]="status() === 'error'" [class.grace]="status() === 'grace'">
  @switch (status()) {
    @case ('loading') {
      <span class="spinner-border spinner-border-sm text-secondary me-2" aria-hidden="true"></span>
      <span class="text-muted">Consultando inicio de operaciones</span>
    }
    @case ('inactive') {
      <span class="text-muted">Operaciones inactivas</span>
    }
    @case ('unavailable') {
      <span class="text-muted">No se pudo consultar el inicio de operaciones</span>
    }
    @case ('success') {
      <fa-icon [icon]="iconsService.faCalendar"></fa-icon>
      &nbsp;
      <div class="base-container">
        <span>Operación iniciada el {{ startOperationsDate() }}</span>
      </div>
    }
    @case ('warning') {
      <fa-icon [icon]="iconsService.faCircleExclamation"></fa-icon>
      &nbsp;
      <div class="base-container">
        <span>Requisitos cumplidos para inicio de operaciones</span>
      </div>
    }
    @case ('error') {
      <fa-icon [icon]="iconsService.faTriangleExclamation"></fa-icon>
      &nbsp;
      <div class="base-container">
        <span>Faltan requisitos para inicio de operaciones</span>
      </div>
    }
    @case ('grace') {
      <fa-icon [icon]="iconsService.faClock"></fa-icon>
      &nbsp;
      <div class="base-container">
        <span>{{ graceLabel() }}</span>
      </div>
    }
  }
</div>
